export const toTitleCase = (str) => {
  if (!str) return ''

  const lowerWords = [
    'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in', 'of', 'on', 'or', 'so', 'the', 'to', 'up', 'with'
  ]

  const acronyms = new Set([
    'AI', 'API', 'CFO', 'CIO', 'CISO', 'CMO', 'COO', 'CPA', 'CRM', 'CSO', 'CTO', 'CVO', 'CXO',
    'CEO', 'DPO', 'EVP', 'HR', 'IT', 'KPI', 'ML', 'MD', 'MVP', 'NPI', 'PHD', 'PM', 'PMO', 'QA',
    'R&D', 'SAP', 'SQL', 'SVP', 'UI', 'UX', 'VP', 'LOL'
  ])

  return str
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((word, idx, arr) => {
      const upperWord = word.toUpperCase()
      if (acronyms.has(upperWord)) return upperWord

      const lowerWord = word.toLowerCase()
      if (lowerWords.includes(lowerWord) && idx !== 0 && idx !== arr.length - 1) {
        return lowerWord
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(' ')
}

export const formatUserTitleAndOrganization = (title, organization) => {
  const parts = [toTitleCase(title), toTitleCase(organization)].filter(Boolean)
  return parts.join(', ')
}